import { FC, useState } from "react";
import WeddingMap from "./WeddingMap";
import PhotoGallery from "./PhotoGallery";
import { WeddingInfo } from "../WeddingInfo/WeddingInfo";
import { useParams } from "react-router-dom";
import useBackgroundMusic from "../Common/useBackgroundMusic";
import {
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisVertical,
  FaVolumeHigh,
  FaVolumeXmark,
} from "react-icons/fa6";
import WeddingCalendar from "../Common/WeddingCalendar";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const ParentHomeScreen: FC = () => {
  const { id } = useParams();
  const info = WeddingInfo.getInfo(id);
  const bgmSongName =
    window.location.hostname == "xn--vj5bwo95cw9x.com"
      ? "to-the-lady.mp3"
      : "wedding-sample-music.mp3";
  const { isMuted, toggleMute } = useBackgroundMusic(
    `${process.env.PUBLIC_URL}/` + `${info.common.parentBGM ?? bgmSongName}`,
  );

  const [openGroomMenuIndex, setOpenGroomMenuIndex] = useState<number | null>(
    null,
  );
  const [openBrideMenuIndex, setOpenBrideMenuIndex] = useState<number | null>(
    null,
  );

  // 복사 기능
  const handleCopy = (text: string, isGroom: boolean) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("복사되었습니다!"); // 복사 완료 알림
      if (isGroom) {
        setOpenGroomMenuIndex(null); // 메뉴 닫기
      } else {
        setOpenBrideMenuIndex(null);
      }
    });
  };

  const [isFirstSlide, setIsFirstSlide] = useState(true); // 첫 번째 슬라이드인지 확인
  const [isLastSlide, setIsLastSlide] = useState(false); // 마지막 슬라이드인지 확인

  const handleSlideChange = (swiper: any) => {
    // 첫 번째 슬라이드인지 확인
    setIsFirstSlide(swiper.isBeginning);
    // 마지막 슬라이드인지 확인
    setIsLastSlide(swiper.isEnd);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 font-gowun">
      <meta name="theme-color" content="#D2D6E1" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="#D2D6E1" />

      {/* 메인 컨텐츠 */}
      <div className="w-full max-w-md bg-parentBackground p-0 text-center">
        <div className="w-full max-w-md bg-white p-0 text-center mb-12 relative">
          {/* 🔊 뮤트 버튼 */}
          <button
            onClick={toggleMute}
            className="absolute top-4 right-4 z-50 bg-white bg-opacity-80 hover:bg-opacity-100 transition p-2 rounded-full"
          >
            {isMuted ? (
              <FaVolumeXmark className="text-black w-5 h-5" />
            ) : (
              <FaVolumeHigh className="text-black w-5 h-5" />
            )}
          </button>

          {/* 메인 콘텐츠 내용들 */}
        </div>

        {/* 웨딩 꽃 */}
        <img
          src={`${process.env.PUBLIC_URL}/wedding-flower.png`}
          alt="웨딩꽃"
          className="mx-auto mt-4 mb-6 w-16 h-16"
        />
        <p className="text-[22px] font-semibold text-parentText">
          {info.parent.startPhrase}
        </p>
        <p className="text-[36px] font-semibold text-parentText">
          {info.parent.shortPhrase}
        </p>

        {/* 메인사진 */}
        <img
          src={info.parent.mainImage}
          alt="메인 사진"
          className="w-full mt-12 mb-6 h-auto"
        />

        {/* 위쪽 꽃 이미지 (가운데 정렬) */}
        <img
          src={`${process.env.PUBLIC_URL}/wedding-flower-up.png`}
          alt="꽃"
          className="mt-12 mb-1 w-16 h-16 mx-auto"
        />
        {info.common.groomName == "신하용" ? (
          <p className="text-[22px] font-semibold text-parentText">
            벨라루체 웨딩홀 (서울점)
            <br />
            2층 벨라홀
            <br />
            2026년 3월 28일(토) 오후 5시30분
          </p>
        ) : (
          <p
            className={`${
              info.common.groomName === "신하용" ? "text-[22px]" : "text-[18px]"
            } font-semibold text-parentText`}
          >
            {info.common.addressInfo.name}
            <br />
            {info.common.weddingDateKR}
          </p>
        )}

        {/* 아래쪽 꽃 이미지 (가운데 정렬) */}
        <img
          src={`${process.env.PUBLIC_URL}/wedding-flower-down.png`}
          alt="꽃"
          className="mt-1 mb-12 w-16 h-16 mx-auto"
        />
        {/* 모시는 글 */}
        <p className="text-2xl font-semibold text-parentText">초대합니다</p>

        <p className="text-[20px] font-regular text-[#292627] mt-4 bg-parentTextBackground m-6 p-6 rounded-lg">
          {info.parent.weddingMessage.split("\n").map((line, index) => (
            <span key={index}>
              {line}
              <br />
            </span>
          ))}
          <br />
          <br />
          <span className="text-xl text-parentText font-bold">
            {info.parent.groomFatherName} ‧ {info.parent.groomMotherName}
          </span>{" "}
          의 {info.parent.groomFamilyTitle}{" "}
          <span className="text-xl text-parentText font-bold">
            {info.common.groomShortName}
          </span>
          <br />
          <span className="text-xl text-parentText font-bold">
            {info.parent.brideFatherName} ‧ {info.parent.brideMotherName}
          </span>{" "}
          의 {info.parent.brideFamilyTitle}{" "}&nbsp;&nbsp;&nbsp;
          <span className="text-xl text-parentText font-bold">
            {info.common.brideShortName}
          </span>
        </p>
       

        {/* 포토 갤러리 */}
        <p className="text-2xl font-semibold text-parentText mt-12">
          포토 갤러리
        </p>
        <p className="text-[16px] mt-2 font-semibold text-parentText">
          {info.parent.photoGalleryPhrase}
        </p>

        <div className="relative mt-3">
          <Swiper
            modules={[Navigation, Pagination]}
            navigation={{
              nextEl: "#parent-next",
              prevEl: "#parent-prev",
            }}
            pagination={{ clickable: true }}
            onSlideChange={handleSlideChange} // 슬라이드 변경 시 상태 업데이트
            className="overflow-hidden h-full"
          >
            {info.parent.photoGalleryImages.map((image, index) => (
              <SwiperSlide key={index}>
                {/* SwiperSlide 안에 flex 컨테이너를 사용해 중앙 정렬 */}
                <div className="flex justify-center items-center h-full w-full">
                  <img
                    src={image}
                    alt={`Post ${index + 1}`}
                    className="object-contain max-h-full max-w-full rounded-md"
                    style={{ aspectRatio: "0.8" }}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <button
            id="parent-prev"
            className={`absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10 ${
              isFirstSlide ? "hidden" : ""
            }`} // 첫 번째 슬라이드에서 왼쪽 버튼 숨기기
          >
            <FaChevronLeft fontFamily="bold" size={12} />
          </button>
          <button
            id="parent-next"
            className={`absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10 ${
              isLastSlide ? "hidden" : ""
            }`} // 마지막 슬라이드에서 오른쪽 버튼 숨기기
          >
            <FaChevronRight fontFamily="bold" size={12} />
          </button>
        </div>

        {/* 오시는 길 */}
        <p className="text-2xl font-semibold mt-6 text-parentText">오시는 길</p>

        {info.common.groomName == "신하용" ? (
          <p className="text-[22px] mt-6 font-semibold text-[#26384f]">
            벨라루체 웨딩홀 (서울점 )
            <br />
            2층 벨라홀 (서울 동대문구 망우로 61)
            <br />
            (1호선 회기역 2번출구 도보 4분거리)
          </p>
        ) : (
          <p
            className={`${
              info.common.groomName === "신하용" ? "text-[22px]" : "text-[16px]"
            } font-semibold text-parentText`}
          >
            {info.common.addressInfo.address}
            <br />
            {info.common.addressInfo.name}
          </p>
        )}

        {/* 네이버 지도 추가 */}
        <div className="mt-6">
          <WeddingMap
            backgroundColor="bg-parentText"
            textColor="text-white"
            addressInfo={info.common.addressInfo}
          />
        </div>

        <WeddingCalendar
          weddingDateKR={info.common.weddingDateKR}
          weddingDate={info.common.weddingDate}
          backgroundColor={"bg-parentText"}
          textColor={"text-parentText"}
        />

        {/* 시 글귀 */}

        {info.parent.poetry && info.parent.poetry.trim() !== "" && (
          <p className="text-md text-parentText font-semibold bg-parentTextBackground mt-4 m-6 p-6 rounded-lg">
            {info.parent.poetry.split("\n").map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
        )}

        {/* 마음 전하실 곳 */}
        <p className="text-2xl mt-12 font-semibold text-parentText">
          마음 전하실 곳
        </p>

        {/* 신랑측 & 신부측 계좌번호 */}
        <div className="flex flex-col mx-4 mt-4 text-left mb-24">
          <div className="p-4 bg-parentTextBackground rounded-lg">
            {info.common.groomAccountInfos.map((content, index) => (
              <div
                key={index}
                className="flex items-center space-x-2 mb-3 relative -mx-2"
              >
                <div className="w-12 h-12 p-1">
                  <img
                    src={content.bankImage}
                    className="w-full h-full object-cover rounded-md"
                  />
                </div>
                {/* 프로필 사진 옆에 유저 이름과 메시지를 수직으로 배치 */}
                <div className="flex flex-col ml-3 text-left justify-center font-semibold flex-[0_0_60%]">
                  <div className="text-[18px] text-parentText break-words leading-snug">
                    {content.familyName == ""
                      ? content.isGroom
                        ? "신랑측"
                        : "신부측"
                      : content.familyName}
                  </div>
                  <div className="text-[20px] text-gray-500 break-all my-1 leading-snug">
                    {content.accountNumber}
                  </div>
                  <div className="text-[18px] text-gray-500 break-words leading-snug">
                    {content.bankName} ({content.name})
                  </div>
                </div>
                {/* 세로 점 3개 아이콘 버튼 */}
                <button
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                  onClick={() =>
                    setOpenGroomMenuIndex(
                      openGroomMenuIndex === index ? null : index,
                    )
                  }
                >
                  <FaEllipsisVertical />
                </button>
                {/* 복사하기 메뉴 */}
                {openGroomMenuIndex === index && (
                  <div className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white text-black text-sm p-2 rounded-md shadow-lg z-10 font-semibold">
                    <button
                      onClick={() => handleCopy(content.accountNumber, true)}
                    >
                      📋 복사하기
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="p-4 bg-parentTextBackground rounded-lg mt-3">
            {info.common.brideAccountInfos.map((content, index) => (
              <div
                key={index}
                className="flex items-center space-x-2 mb-3 relative -mx-2"
              >
                <div className="w-12 h-12 p-1">
                  <img
                    src={content.bankImage}
                    className="w-full h-full object-cover rounded-md"
                  />
                </div>
                {/* 프로필 사진 옆에 유저 이름과 메시지를 수직으로 배치 */}
                <div className="flex flex-col ml-3 text-left justify-center flex-1  font-semibold">
                  <div className="text-[18px] text-parentText break-words leading-snug">
                    {content.familyName == ""
                      ? content.isGroom
                        ? "신랑측"
                        : "신부측"
                      : content.familyName}
                  </div>
                  <div className="text-[20px] text-gray-500 break-all my-1 leading-snug">
                    {content.accountNumber}
                  </div>
                  <div className="text-[18px] text-gray-500 break-words leading-snug">
                    {content.bankName} ({content.name})
                  </div>
                </div>
                {/* 세로 점 3개 아이콘 버튼 */}
                <button
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                  onClick={() =>
                    setOpenBrideMenuIndex(
                      openBrideMenuIndex === index ? null : index,
                    )
                  }
                >
                  <FaEllipsisVertical />
                </button>
                {/* 복사하기 메뉴 */}
                {openBrideMenuIndex === index && (
                  <div className="absolute right-8 top-1/2 transform -translate-y-1/2 bg-white text-black text-sm p-2 rounded-md shadow-lg z-10 font-semibold">
                    <button
                      onClick={() => handleCopy(content.accountNumber, false)}
                    >
                      📋 복사하기
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* 마지막 사진 */}
        <div className="relative w-full mt-12">
          {/* 그라데이션을 덮을 div, 상단 1/10만큼만 적용 */}
          <div className="absolute -top-3 left-0 w-full h-[10%] bg-gradient-to-b from-white to-transparent" />

          {/* 마지막 사진 */}
          <img
            src={info.parent.endImage}
            alt="마지막 사진"
            className="w-full h-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default ParentHomeScreen;
